/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiscountCouponDto } from '../../models/discount-coupon-dto';
import { DiscountCouponPaginateResponse } from '../../models/discount-coupon-paginate-response';

export interface PostDiscountCouponCreate$Params {
      body: DiscountCouponDto
}

export function postDiscountCouponCreate(http: HttpClient, rootUrl: string, params: PostDiscountCouponCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<DiscountCouponPaginateResponse>> {
  const rb = new RequestBuilder(rootUrl, postDiscountCouponCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DiscountCouponPaginateResponse>;
    })
  );
}

postDiscountCouponCreate.PATH = '/v1/discount-coupon';
